// Performance monitoring utilities
export const measurePerformance = () => {
  // Core Web Vitals measurement
  if ('web-vital' in window) return;

  const observer = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      // Log performance metrics for monitoring
      if (entry.entryType === 'largest-contentful-paint') {
        console.log('LCP:', entry.startTime);
      }
      if (entry.entryType === 'first-input') {
        const fidEntry = entry as PerformanceEventTiming;
        console.log('FID:', fidEntry.processingStart - fidEntry.startTime);
      }
      if (entry.entryType === 'layout-shift') {
        const clsEntry = entry as any;
        console.log('CLS:', clsEntry.value);
      }
    });
  });

  observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
};

// Bundle size tracker
export const trackBundleSize = () => {
  if ('performance' in window && 'getEntriesByType' in window.performance) {
    const resources = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
    const jsResources = resources.filter(resource => resource.name.includes('.js'));
    const totalJSSize = jsResources.reduce((total, resource) => total + (resource.transferSize || 0), 0);
    
    console.log('Total JS bundle size:', (totalJSSize / 1024).toFixed(2), 'KB');
    
    // Track if bundle exceeds target size (500KB)
    if (totalJSSize > 500 * 1024) {
      console.warn('Bundle size exceeds 500KB target');
    }
  }
};

// Image optimization checker
export const checkImageOptimization = () => {
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    if (!img.src.includes('webp') && !img.src.includes('avif')) {
      console.warn('Non-optimized image format:', img.src);
    }
  });
};